import { all, takeEvery, call, put } from "redux-saga/effects";
import { login, logout } from "services/apis/account";
import { history } from "redux/store";
import actions from "./actions";
import store from "store";

function* loading(isLoading = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
    },
  });
}

export function* LOGIN({ payload }) {
  const { username, password } = payload;
  yield loading(true);

  const response = yield call(login, username, password);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        data: response,
        loading: false,
        isLogin: true,
      },
    });
    yield history.push("/");
  }

  if (!response) {
    yield loading(false);
  }
}

export function* LOGOUT() {
  yield call(logout);
  yield put({
    type: actions.SET_STATE,
    payload: {
      isLogin: false,
      loading: false,
      data: {},
    },
  });

  yield history.push("/login");

  store.clearAll();
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOGIN, LOGIN), takeEvery(actions.LOGOUT, LOGOUT)]);
}
